import PropTypes from 'prop-types';
import { TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const RESOLUTION_NOTE_MAX_LENGTH = 255;

// Reviewer's rationale for approving or dismissing a cancellation request.
const ResolutionNoteField = ({ value, onChange, label, required = false }) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" sx={{ mt: 2, mb: 0.5 }}>
        {label}
        {required && <span aria-hidden="true"> *</span>}
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        inputProps={{ maxLength: RESOLUTION_NOTE_MAX_LENGTH }}
        helperText={t('POLICY_DETAILS.CANCELLATION_MANAGEMENT.noteCounter', {
          length: value.length,
          max: RESOLUTION_NOTE_MAX_LENGTH,
        })}
        sx={{
          '& .MuiInputBase-root': { width: '100%' },
          '& .MuiInputBase-input': { padding: 0, lineHeight: 1.4 },
        }}
      />
    </>
  );
};

ResolutionNoteField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default ResolutionNoteField;
